import { render, staticRenderFns } from "./calcdictItemData.vue?vue&type=template&id=5972ffeb&scoped=true&"
import script from "./calcdictItemData.vue?vue&type=script&lang=js&"
export * from "./calcdictItemData.vue?vue&type=script&lang=js&"
import style0 from "./calcdictItemData.vue?vue&type=style&index=0&id=5972ffeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972ffeb",
  null
  
)

export default component.exports